<button
  mat-flat-button
  color="accent"
  class="reverse"
  [matMenuTriggerFor]="dropdownMenuOne"
>
  {{ buttonLabel }}
  <mat-icon>expand_more</mat-icon>
</button>

<mat-menu #dropdownMenuOne="matMenu">
  @for (item of menuItems; track item; let i = $index) {
    <button mat-menu-item (click)="selection(i)">
      {{ item }}
    </button>
  }
</mat-menu>
